export default __webpack_public_path__ + "static/media/fabEyeCream.c411d03a.webp";